import { useState, useRef, useEffect } from 'react';
import { Volume2 } from 'lucide-react';
import styles from './volume.module.css';

interface VolumeControlProps {
  initialVolume?: number;
  className?: string;
  onChange?: (volume: number) => void;
  defaultVolume?: number; // Varsayılan ses seviyesi
}

const VolumeControl = ({ initialVolume = 30, className: _className, onChange, defaultVolume }: VolumeControlProps) => {
  const [volume, setVolume] = useState(defaultVolume || initialVolume);
  const [isOpen, setIsOpen] = useState(true);
  const inputRef = useRef<HTMLInputElement>(null);

  const activeColor = '#ffffff';
  const inactiveColor = '#868686';

  // Input değeri değiştiğinde gradient'i güncelle
  const updateRangeBackground = (value: number) => {
    if (inputRef.current) {
      const min = parseInt(inputRef.current.min);
      const max = parseInt(inputRef.current.max);
      const ratio = ((value - min) / (max - min)) * 100;
      inputRef.current.style.background = `linear-gradient(0deg, ${activeColor} ${ratio}%, ${inactiveColor} ${ratio}%)`;
    }
  };

  // İlk render ve volume değiştiğinde gradient'i güncelle
  useEffect(() => {
    updateRangeBackground(volume);
  }, [volume]);

  const handleVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseInt(e.target.value);
    setVolume(newVolume);
    updateRangeBackground(newVolume);
    if (onChange) {
      onChange(newVolume);
    }
  };

  return (
    <div className={styles.volumeContainer}>
      {isOpen && (
        <div className={styles.volumeSubContainer}>
          <input
            ref={inputRef}
            type="range"
            min="0"
            max="100"
            value={volume}
            onChange={handleVolumeChange}
            className={styles.inputVolumeRange}
            style={{
              WebkitAppearance: 'slider-vertical',
              writingMode: 'vertical-lr',
            }}
          />
        </div>
      )}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 rounded-full text-white hover:text-white/70 outline-none border-none"
      >
        <Volume2 size={20} />
      </button>
    </div>
  );
};

export default VolumeControl;
